webpackJsonp(["components/fileUploadField"],{

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/file-upload-field/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.fileUploader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _baseBehaviour = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/base-behaviour/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var log = (0, _debug2.default)('fus078/components/file-upload-field');

var fileUploader = exports.fileUploader = function (_Base) {
	_inherits(fileUploader, _Base);

	function fileUploader(element, options) {
		_classCallCheck(this, fileUploader);

		var _this = _possibleConstructorReturn(this, (fileUploader.__proto__ || Object.getPrototypeOf(fileUploader)).call(this, element, options));

		_this.$dropzone = _this.$element.find(_this.options.dropzoneselector);
		_this.$input = _this.$element.find(_this.options.inputfieldselector);
		__webpack_require__.e/* import() */("vendor/jquery.fineuploader@3.5.0").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/jquery.fineuploader@3.5.0.js")).then(_this.init.bind(_this));
		log('constructed', _this.element);
		return _this;
	}

	_createClass(fileUploader, [{
		key: 'init',
		value: function init() {
			this.$dropzone.fineUploader({
				request: {
					endpoint: this.options.endpoint,
					customHeaders: { Accept: 'application/json' }
				},
				debug: false,
				multiple: false,
				button: this.$element,
				validation: {
					allowedExtensions: this.options.allowedextensions.split(','),
					sizeLimit: this.options.sizelimit
				},
				showMessage: this.showMessage.bind(this)
			}).on('submit', this.onSubmit.bind(this)).on('complete', this.onComplete.bind(this)).on('error', this.onError.bind(this));
			log('fineUploader.bound', this.$dropzone);
		}
	}, {
		key: 'onError',
		value: function onError(event, id, name, errorReason, xhrOrXdr) {
			log('error', { el: this.element, id: id, name: name, errorReason: errorReason });
			this.$dropzone.empty().append('An error occurred uploading your file: ' + errorReason);
		}
	}, {
		key: 'showMessage',
		value: function showMessage(message) {
			log('showMessage', { el: this.element, message: message });
			this.$dropzone.empty().append('An error occurred uploading your file: ' + message);
		}
	}, {
		key: 'onComplete',
		value: function onComplete(event, id, fileName, responseJSON) {
			log('onComplete', { el: this.element, id: id, fileName: fileName, responseJSON: responseJSON });
			this.$dropzone.empty();
			if (responseJSON.success) {
				var filename = responseJSON.Filename;
				if (filename !== "") {
					var origFilename = responseJSON.Description;
					this.$dropzone.find(".qq-upload-list").empty();
					this.$dropzone.empty().append(origFilename);
					this.$input.val(filename);
				}
				this.$input.trigger('blur');
			}
		}
	}, {
		key: 'onSubmit',
		value: function onSubmit() {
			log('onSubmit', { el: this.element });
			this.$dropzone.empty().append('Uploading...');
		}
	}]);

	return fileUploader;
}(_baseBehaviour.Base);

fileUploader.componentName = 'fileuploader';

fileUploader.DEFAULTS = {
	dropzoneselector: '[data-fileuploader-dropzone]',
	inputfieldselector: '[data-fileuploader-input]',
	allowedextensions: 'zip,doc,docx,pdf',
	endpoint: '/',
	sizelimit: 4 * 1024 * 1024
};

/***/ }),

/***/ "/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/video-background/component.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.videoBackground = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debug = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/node_modules/debug/src/browser.js");

var _debug2 = _interopRequireDefault(_debug);

var _baseBehaviour = __webpack_require__("/opt/app/node_modules/babel-loader/lib/index.js??ref--5-0!/opt/app/node_modules/eslint-loader/index.js!/opt/app/client/src/site__fus078/components/base-behaviour/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var log = (0, _debug2.default)('fus078/components/video-background');

var videoBackground = exports.videoBackground = function (_Base) {
	_inherits(videoBackground, _Base);

	_createClass(videoBackground, null, [{
		key: 'detectAspectRatio',
		value: function detectAspectRatio() {
			var windowWidth = $(window).width();
			var windowHeight = $(window).height();
			var width = 1280;
			var height = 720;
			var windowProportion = windowWidth / windowHeight;
			var origProportion = width / height;
			var proportion = windowHeight / height;

			if (windowProportion >= origProportion) {
				proportion = windowWidth / width;
			}

			return proportion;
		}
	}]);

	function videoBackground(element, options) {
		_classCallCheck(this, videoBackground);

		var _this = _possibleConstructorReturn(this, (videoBackground.__proto__ || Object.getPrototypeOf(videoBackground)).call(this, element, options));

		__webpack_require__.e/* import() */("vendor/jquery.backgroundvideo").then(__webpack_require__.bind(null, "/opt/app/client/src/vendor/jquery.backgroundvideo.js")).then(_this.init.bind(_this));
		log('constructed', _this.element);
		return _this;
	}

	_createClass(videoBackground, [{
		key: 'init',
		value: function init() {
			this.attach();
			$(window).resize(this.attach.bind(this));
		}
	}, {
		key: 'setAspectRatio',
		value: function setAspectRatio() {
			var aspectRatio = videoBackground.detectAspectRatio();
			var width = 1280;
			var height = 720;
			this.$element.find('video').width(aspectRatio * width);
			this.$element.find('video').height(aspectRatio * height);

			this.centerVideo();
		}
	}, {
		key: 'centerVideo',
		value: function centerVideo() {
			var centerX = ($(window).width() >> 1) - (this.$element.find('video').width() >> 1) | 0;
			var centerY = ($(window).height() >> 1) - (this.$element.find('video').height() >> 1) | 0;

			this.$element.find('video').css({ 'left': centerX });
		}
	}, {
		key: 'attach',
		value: function attach() {

			var loop = this.$element.attr('data-loop-video');
			var autoplay = this.$element.attr('data-autoplay-video');
			var urlogv = this.$element.attr('data-video-ogv');
			var urlmp4 = this.$element.attr('data-video-mp4');
			var urlwebm = this.$element.attr('data-video-webm');
			var source = [];

			// If no touch specific vids selected load the desktop ones instead
			if (source.length == 0) {
				if (urlogv.length > 0) {
					source.push([urlogv, 'video/ogg']);
				}
				if (urlmp4.length > 0) {
					source.push([urlmp4, 'video/mp4']);
				}
				if (urlwebm.length > 0) {
					source.push([urlwebm, 'video/webm']);
				}
			}

			// Don't load video on mobile
			if (this.$element.is(':visible') && source.length > 0) {
				this.$element.find('#video-background-controls').show();
				this.$element.videobackground({
					videoSource: source,
					loop: loop == 'true',
					autoplay: autoplay == 'true',
					resize: false,
					muted: true,
					preload: 'none',
					controlPosition: '#video-background-controls > .column',
					controlText: ['', '', '', ''],
					loadedCallback: function loadedCallback() {
						$(this).addClass('loaded');
					}
				});
				this.setAspectRatio();
			} else {
				this.$element.find('#video-background-controls').hide();
			}
		}
	}]);

	return videoBackground;
}(_baseBehaviour.Base);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("/opt/app/client/src/vendor/jquery@2.1.1.js")))

/***/ })

});


// WEBPACK FOOTER //
// scripts/components/fileUploadField--e56009c78cf92f287f72.js